import { Link } from "wouter";
import { hrefs } from "../root-layout/fmt";
import * as css from "./style.css";

export function PreorderButton() {
  return (
    <Link href={hrefs.buy()} className={css.cta}>
      Get the Rules
    </Link>
  );
}
